export const urlBinder = (url: string, params: any[]) => {
  let stringsToReplace = url.match(/\{\w*\}/g);
  stringsToReplace?.forEach((it, index) => {
    url = url.replace(it, params[index] ?? "");
  });
  return url;
};
